/* IMPORTANT!!!! for other languages change countryCode and api-urls (/src/views) */
import { createI18n } from 'vue-i18n'
import de from './de.json'

const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'de',
    globalInjection: true,
    legacy: false,
    messages: {
        de
    },
    escapeParameterHtml: false,
    messageResolver: null
})

export default i18n